import type { IconProps } from './types';

const Tablet01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 18, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 13.5 16.5"
      preserveAspectRatio="none"
      fill="none"
    >
      <path
        d="M6.75 12.375H6.7575M3.15 15.75H10.35C11.1901 15.75 11.6101 15.75 11.931 15.5865C12.2132 15.4427 12.4427 15.2132 12.5865 14.931C12.75 14.6101 12.75 14.1901 12.75 13.35V3.15C12.75 2.30992 12.75 1.88988 12.5865 1.56902C12.4427 1.28677 12.2132 1.0573 11.931 0.913492C11.6101 0.750001 11.1901 0.750001 10.35 0.750001H3.15C2.30992 0.750001 1.88988 0.750001 1.56902 0.913492C1.28677 1.0573 1.0573 1.28677 0.913492 1.56902C0.750001 1.88988 0.750001 2.30992 0.750001 3.15V13.35C0.750001 14.1901 0.750001 14.6101 0.913492 14.931C1.0573 15.2132 1.28677 15.4427 1.56902 15.5865C1.88988 15.75 2.30992 15.75 3.15 15.75ZM7.125 12.375C7.125 12.5821 6.95711 12.75 6.75 12.75C6.54289 12.75 6.375 12.5821 6.375 12.375C6.375 12.1679 6.54289 12 6.75 12C6.95711 12 7.125 12.1679 7.125 12.375Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Tablet01Icon };
